import { RootState } from '../../store/reducers';
export const generalSelector = (state: RootState) => state.general;
export const currencyListToOpenSelector = (state: RootState) => state.general.currencyListToOpen;